import { SyncLiner24 } from 'seagull/icons';
import { AccountingSyncIcon } from "./AccountingSyncIcon";
import { ReconciledIcon } from "../ReconciledIcon";
import { Accounting } from "../../../types/api.model";
import { jsx as _jsx } from "react/jsx-runtime";
export const qboIconMap = {
  pending: /*#__PURE__*/_jsx(AccountingSyncIcon, {
    intent: "pending",
    prefix: "qbo"
  }),
  error: /*#__PURE__*/_jsx(AccountingSyncIcon, {
    intent: "error",
    prefix: "qbo"
  }),
  success: /*#__PURE__*/_jsx(AccountingSyncIcon, {
    intent: "success",
    prefix: "qbo"
  }),
  syncing: /*#__PURE__*/_jsx(SyncLiner24, {
    testId: "qbo-in-progress"
  }),
  done: /*#__PURE__*/_jsx(ReconciledIcon, {})
};
export const xeroIconMap = {
  pending: /*#__PURE__*/_jsx(AccountingSyncIcon, {
    intent: "pending",
    prefix: "xero"
  }),
  error: /*#__PURE__*/_jsx(AccountingSyncIcon, {
    intent: "error",
    prefix: "xero"
  }),
  success: /*#__PURE__*/_jsx(AccountingSyncIcon, {
    intent: "success",
    prefix: "xero"
  }),
  syncing: /*#__PURE__*/_jsx(SyncLiner24, {}),
  done: /*#__PURE__*/_jsx(ReconciledIcon, {})
};
export const accountingIconMap = {
  [Accounting.QBO]: qboIconMap,
  [Accounting.Xero]: xeroIconMap
};